import { useCallback, useEffect } from "react";

/**
 * Enables capturing the [ key to toggle the sidebar
 */
export const useSidebarToggleShortcut = (setTriggered: (value: boolean) => void) => {
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key !== "[") {
                return;
            }

            const isInputElement =
                event.target instanceof HTMLInputElement ||
                event.target instanceof HTMLTextAreaElement ||
                (event.target instanceof HTMLElement && event.target.isContentEditable);
            if (isInputElement) {
                return;
            }

            // to not interfere with the things like modal dismissals
            if (event.defaultPrevented) {
                return;
            }
            event.preventDefault();
            setTriggered(true);
        },
        [setTriggered],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);
};
